import styles from './title.module.css';
import globalStyles from '../result.module.css';

interface Props {
  mainTitle: string;
  addressText: string;
  owners: []
}

const TitleDisplay = ({ addressText, mainTitle, owners }: Props) => {
  const owner = owners
    ? owners[0]
    : null

  return (
    <div className={`${styles.TitleContainer}`}>
      <div className={styles.titleWrapper}>

        <h1 className={styles.titleContent}>
          <span className={globalStyles.titleText}>{mainTitle} </span>
          <span className={`${globalStyles.largeText} ${globalStyles.lightColorText}`}>
            {addressText}
          </span>
        </h1>
        {
          owner && (
            <div className={styles.ownersContainer}>
              <span>Owned by</span>
              <div>
                { owner.logo_uri
                  ? <img alt={`${owner.company_name} logo`} src={`${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${owner.logo_uri}`} loading="lazy" height="auto" width="auto"></img>
                  : <b>{owner.company_name}</b>
                  }
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
}

export default TitleDisplay;